export default __webpack_public_path__ + "static/media/CodesAffiliation.91d0fff7.png";